import React, { Component } from 'react';
import Select from 'react-select';
import withRouter from "../../Utils/withRouter";
import axios from "axios";
import { formatDate, } from "../../Components/InputElements";
import Swal from "sweetalert2";
import { ConfigContext } from "../../Context/ConfigContext";
import { decodeData, genderOptions, emergencyContactPerson } from '../../Constants/constants';
import { NoRecords } from '../../Components/Shimmer';
class FamilyDetails extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      family_data:[],
      employee_degree: '',
      institute_university: '',
      year_of_passout: '',
      percentage_grade: '',
      employee_qualification_document: '',
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      keyword: "",
      from_date: "",
      to_date: "",
      family_Member_Name: '',
      relation: 'No',
      emergency_Contact_Person: 'Brother',
      is_Dependend: 'No',
      date_Of_Birth: '',
      gender: 'Male',
      mobile_Number: '',
      errors: {},
      decodedData: [],
    };
    this.closeRef = React.createRef();
  }
  componentDidMount() {
    this.setState({ family_data: this.props.familyData }, (prevState) => {
      // this.GetList();
      console.log("this.props.familyData====>",this.props.familyData);
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const errors = this.validateForm();

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const employee_id = this.props.params.employee_id;
    var formData = {
      employee_id: employee_id,
      family_member_name: this.state.family_Member_Name,
      relation: this.state.relation,
      family_member_relation: this.state.emergency_Contact_Person,
      family_member_dependent: this.state.is_Dependend,
      family_member_dob: this.state.date_Of_Birth,
      family_member_gender: this.state.gender,
      family_member_contact_number: this.state.mobile_Number,

    }

    
  };
handleRadioChange = (name, value) => {
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  handleSelectChange = (name, selectedOption) => {
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  validateForm = () => {
    const errors = {};
    const mobileRegex = /^[0-9]{10}$/;

    if (!this.state.family_Member_Name) errors.family_Member_Name = 'Family  Member Name is required';
    if (!this.state.emergency_Contact_Person) errors.emergency_Contact_Person = 'Relation is required';
    if (!this.state.is_Dependend) errors.is_Dependend = 'Dependend Field is required';
    if (!this.state.date_Of_Birth) errors.date_Of_Birth = 'Date Of Birth is required';
    if (!this.state.gender) errors.gender = 'Family Member Gender is required';
    if (!this.state.mobile_Number) errors.mobile_Number = 'Family Member Mobile number is required';
    if (this.state.mobile_Number && !mobileRegex.test(this.state.mobile_Number)) errors.mobile_Number = 'Family Member Mobile number is Invailid';
    return errors;
  };

  render() {
    const { family_data,errors } = this.state;


    return (
      <div>
        <div className='d-flex justify-content-between align-items-center'>
          <div><h5>Family Details</h5></div>
          <div>
            {/* <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#FamilyDetails">
              <i className="ri-menu-add-fill" style={{ fontSize: "16px" }} />
            </button> */}
            <div className="modal fade" id="FamilyDetails" tabIndex={-1} aria-labelledby="exampleModalgridLabel" aria-modal="true">
              <div className="modal-dialog modal-xl">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalgridLabel">Family Details</h5>
                    <button type="button" className="btn-close" ref={this.closeRef} data-bs-dismiss="modal" aria-label="Close" />
                  </div>
                  <div className="modal-body">
                    <div className="container mt-2">
                      <form onSubmit={this.handleSubmit}>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="family_Member_Name" className="form-label">Family Member Name:</label>
                            <input
                              type="text"
                              id="family_Member_Name"
                              name="family_Member_Name"
                              value={family_data?.family_Member_Name}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.family_Member_Name ? 'is-invalid' : ''}`}
                             
                            />
                            {errors.family_Member_Name && <div className="invalid-feedback">{errors.family_Member_Name}</div>}
                          </div>

                          <div className="col-md-6 mb-3">
                            <div>
                              <label htmlFor="relation" className="form-label">Relation:</label>
                            </div>
                            <Select
                              id="emergency_Contact_Person"
                              name="emergency_Contact_Person"
                              className={`${errors.emergency_Contact_Person ? 'is-invalid' : ''}`}
                              value={emergencyContactPerson.find(option => option.value === family_data?.emergency_Contact_Person) }
                              onChange={(selectedOption) => this.handleSelectChange('emergency_Contact_Person', selectedOption)}
                              options={emergencyContactPerson}
                             
                            />
                            {errors.emergency_Contact_Person && <div className="text-danger">{errors.emergency_Contact_Person}</div>}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="dateOfBirth" className="form-label">Date Of Birth:</label>
                            <input
                              type="date"
                              id="date_Of_Birth"
                              name="date_Of_Birth"
                              value={family_data?.date_Of_Birth}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.date_Of_Birth ? 'is-invalid' : ''}`}
                              
                            />
                            {errors.date_Of_Birth && <div className="invalid-feedback">{errors.date_Of_Birth}</div>}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="gender" className="form-label"> Gender:</label>
                            <Select
                              id="gender"
                              name="gender"
                              value={genderOptions.find(option => option.value === family_data?.gender) }
                              onChange={(selectedOption) => this.handleSelectChange('gender', selectedOption)}
                              options={genderOptions}
                              
                            />
                            {errors.gender && <div className="text-danger">{errors.gender}</div>}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="mobile_Number" className="form-label">Mobile Number:</label>
                            <input
                              type="number"
                              id="mobile_Number"
                              name="mobile_Number"
                              value={family_data?.mobile_Number}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.mobile_Number ? 'is-invalid' : ''}`}
                              
                            />
                            {errors.mobile_Number && <div className="invalid-feedback">{errors.mobile_Number}</div>}
                          </div>
                          <div className="col-md-6 mb-3">
                            <div>
                              <label htmlFor="is_Dependend" className="form-label">Dependent:</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="dependentYes"
                                name="is_Dependend"
                                value="Yes"
                                checked={family_data?.is_Dependend === 'Yes'}
                                onChange={() => this.handleRadioChange('is_Dependend', 'Yes')}
                                className={`form-check-input ${errors.is_Dependend ? 'is-invalid' : ''}`}
                              />
                              <label htmlFor="dependentYes" className="form-check-label">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="dependentNo"
                                name="is_Dependend"
                                value="No"
                                checked={family_data?.is_Dependend === 'No'}
                                onChange={() => this.handleRadioChange('is_Dependend', 'No')}
                                className={`form-check-input ${errors.is_Dependend ? 'is-invalid' : ''}`}
                              />
                              <label htmlFor="dependentNo" className="form-check-label">No</label>
                            </div>
                            {errors.is_Dependend && <div className="text-danger">{errors.is_Dependend}</div>}
                          </div>
                        </div>
                        <div className="d-flex justify-content-end">
                          <button type="submit" className="btn btn-success btn-label waves-effect right waves-light">
                            <i className="bx bx-save label-icon align-middle fs-16 ms-2" /> Save </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}> 
          <table className={` position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped`}>
            <thead className="bg-primary text-light bg-gradient sticky-top z-1">
              <tr>
                <th className='noWrap'>Member Name</th>
                <th>Relation</th>
                <th className='noWrap'>Date Of Birth</th>
                <th>Gender</th>
                <th className='noWrap'>Mobile Number</th>
                <th>Dependent</th>
                {/* <th className="text-center">Action</th> */}

              </tr>
            </thead>
                    {family_data?.length === 0 ? (
                            <tbody>
                              <tr>
                                <td colSpan={11}>
                                  <NoRecords />
                                </td>
                              </tr>
                            </tbody>
                          ) : (
                            <tbody>
              {family_data?.map((row) => {
                return (
                  <tr key={row?.employee_family_id ? (row?.employee_family_id):"--"}>
                    <td>{row?.family_member_name ? (row?.family_member_name):"--"}</td>
                    <td>{row?.family_member_relation ? (row?.family_member_relation):"--"}</td>
                    <td>{row?.family_member_dob ? formatDate(row?.family_member_dob):"--"}</td>
                    <td>{row?.family_member_gender ? (row?.family_member_gender):"--"}</td>
                    <td>{row?.family_member_contact_number ?(row?.family_member_contact_number):"--"}</td>
                    <td>{row?.family_member_dependent ?(row?.family_member_dependent):"--"}</td>
                    {/* <td className="d-flex justify-content-around"> */}
                    {/* <button
                           onClick={() =>
                            this.handleEdit(row)
                            
                        }
                              data-bs-toggle="modal" data-bs-target="#FamilyDetails"
                                className="btn-icon btn btn-sm btn-outline-primary">
                                <i className="ri-edit-box-line"></i>
                          </button> */}
                      {/* <button
                        onClick={() =>
                          this.handleDelete(row.employee_family_id)
                        }
                        className="btn-icon btn btn-sm btn-outline-danger"
                      >
                        {" "}
                        <i className="ri-delete-bin-line"></i>{" "}
                      </button> */}
                    {/* </td> */}
                  </tr>
                );
              })}
                            </tbody>
                           )}
  
          </table>
        </div>
      </div>

    );
  }
}

export default withRouter(FamilyDetails);
